var swiper = new Swiper(".listArticleproductsSwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".js-list-article-products-swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".js-list-article-products-swiper-button-next",
    prevEl: ".js-list-article-products-swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: false,
      loop: false
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
      centeredSlides: false,
      loop: false
    },
  },
});